module.exports = __webpack_public_path__ + "img/9788925531465.bfc42095.jpg";